import { render } from "./bookmarks.vue?vue&type=template&id=17e054ed"
const script = {}
script.render = render

export default script